import * as React from 'react'

function SvgComponent (props) {
  return (
    <svg
      className='prefix__animated'
      id='prefix__freepik_stories-maintenance'
      viewBox='0 0 500 500'
      {...props}
    >
      <style>
        {
          '@keyframes lightSpeedLeft{60%{transform:skewX(-10deg);opacity:1}80%{transform:skewX(2deg)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes zoomOut{0%{opacity:0;transform:scale(1.5)}to{opacity:1;transform:scale(1)}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}svg#prefix__freepik_stories-maintenance:not(.prefix__animated) .prefix__animable{opacity:0}'
        }
      </style>
      <g
        id='prefix__freepik--background-complete--inject-80'
        className='prefix__animable'
        style={{
          transformOrigin: '250px 224.82px',
          animation:
            '1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedLeft',
          animationDelay: '0s'
        }}
      >
        <path
          style={{
            transformOrigin: '250px 382.525px'
          }}
          id='prefix__elr6j8r3xas2'
          className='prefix__animable'
          fill='#e0e0e0'
          d='M0 382.4h500v.25H0z'
        />
        <path
          style={{
            transformOrigin: '80.535px 394.515px'
          }}
          id='prefix__elnw5vg7ui7sg'
          className='prefix__animable'
          fill='#e0e0e0'
          d='M51.65 394.39h57.77v.25H51.65z'
        />
        <path
          style={{
            transformOrigin: '222.5px 389.085px'
          }}
          id='prefix__elx7yjo6lbm8'
          className='prefix__animable'
          fill='#e0e0e0'
          d='M209.34 388.96h26.32v.25h-26.32z'
        />
        <path
          style={{
            transformOrigin: '270.92px 388.955px'
          }}
          id='prefix__elcjhkz4zeyw'
          className='prefix__animable'
          fill='#e0e0e0'
          d='M245.28 388.83h51.28v.25h-51.28z'
        />
        <path
          style={{
            transformOrigin: '387.925px 391.955px'
          }}
          id='prefix__elvzl6dka9f1'
          className='prefix__animable'
          fill='#e0e0e0'
          d='M381.68 391.83h12.49v.25h-12.49z'
        />
        <path
          style={{
            transformOrigin: '313.64px 391.955px'
          }}
          id='prefix__el0g0dqxib6rvc'
          className='prefix__animable'
          fill='#e0e0e0'
          d='M288.73 391.83h49.82v.25h-49.82z'
        />
        <path
          style={{
            transformOrigin: '124.05px 394.515px'
          }}
          id='prefix__elrhacwb57htm'
          className='prefix__animable'
          fill='#e0e0e0'
          d='M119.1 394.39h9.9v.25h-9.9z'
        />
        <path
          style={{
            transformOrigin: '423.955px 391.955px'
          }}
          id='prefix__el0bbyx0erbg3c'
          className='prefix__animable'
          fill='#e0e0e0'
          d='M402.33 391.83h43.25v.25h-43.25z'
        />
        <path
          d='M237 337.8H43.91a5.71 5.71 0 01-5.7-5.71V60.66a5.71 5.71 0 015.7-5.66H237a5.71 5.71 0 015.71 5.71v271.38a5.71 5.71 0 01-5.71 5.71zM43.91 55.2a5.46 5.46 0 00-5.45 5.46v271.43a5.46 5.46 0 005.45 5.46H237a5.47 5.47 0 005.46-5.46V60.66A5.47 5.47 0 00237 55.2z'
          style={{
            transformOrigin: '140.46px 196.4px'
          }}
          id='prefix__el6savowncmy9'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M453.31 337.8h-193.1a5.72 5.72 0 01-5.71-5.71V60.66a5.72 5.72 0 015.71-5.66h193.1a5.71 5.71 0 015.69 5.66v271.43a5.71 5.71 0 01-5.69 5.71zM260.21 55.2a5.47 5.47 0 00-5.46 5.46v271.43a5.47 5.47 0 005.46 5.46h193.1a5.47 5.47 0 005.46-5.46V60.66a5.47 5.47 0 00-5.46-5.46z'
          style={{
            transformOrigin: '356.75px 196.4px'
          }}
          id='prefix__elj201w1fdwnj'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M76.62 136.81c-4.36-9.42-.9-16.12 9.75-16.12 6.69 0 15 2.64 23 6.93.92-2.45 3.48-3.91 7.61-3.91 7.27 0 17.3 4.53 25.16 10.93a14.53 14.53 0 018.19-2.44c7-.29 15.38 2.32 22.71 6.56a4.47 4.47 0 013.23-1.22c4-.16 9.43 2.47 12.13 5.87.17.22.31.42.46.63H74.5a8.5 8.5 0 012.12-7.23z'
          style={{
            transformOrigin: '131.616px 132.365px'
          }}
          id='prefix__el8dx3173ye88'
          className='prefix__animable'
          fill='#f5f5f5'
        />
        <path
          d='M206.32 92a9.28 9.28 0 011.06-.06c-.33-3.68 1.58-6 5.65-6 2.94 0 6.54 1.23 10.22 3.31-1.05-7.14 2.31-11.79 9.94-11.79 6.15 0 13.93 3 21.62 8 .67-2.8 2.94-4.48 6.75-4.48 6.68 0 16.19 5.18 23.81 12.5a10.93 10.93 0 017.37-2.8c6.37-.33 14.27 2.65 21.28 7.51a3.47 3.47 0 012.9-1.4c3.48-.17 8.28 2.5 11.06 6.09H200.72c-2.99-5.49-.61-10.25 5.6-10.88z'
          style={{
            transformOrigin: '263.708px 90.17px'
          }}
          id='prefix__elqybhqurkig'
          className='prefix__animable'
          fill='#f5f5f5'
        />
        <path
          d='M377 76.41c-2.8-6-.57-10.35 6.26-10.35 4.29 0 9.61 1.69 14.79 4.45.58-1.57 2.23-2.52 4.88-2.52 4.67 0 11.1 2.92 16.14 7a9.35 9.35 0 015.26-1.56c4.46-.19 9.87 1.48 14.57 4.21a2.85 2.85 0 012.07-.79 10.74 10.74 0 017.79 3.77l.3.4h-75.55c-2.39-2.12.25-4.51 3.49-4.61z'
          style={{
            transformOrigin: '410.824px 73.54px'
          }}
          id='prefix__elnfnr10xlpal'
          className='prefix__animable'
          fill='#f5f5f5'
        />
        <path
          style={{
            transformOrigin: '106.18px 327.96px'
          }}
          id='prefix__elx1s64ludanc'
          className='prefix__animable'
          fill='#ebebeb'
          d='M89.15 273.52h34.06V382.4H89.15z'
        />
        <path
          style={{
            transformOrigin: '139.995px 309.015px'
          }}
          className='prefix__animable'
          fill='#f5f5f5'
          transform='rotate(180)'
          d='M112.07 235.63h55.85V382.4h-55.85z'
          id='prefix__elbuxdo6sxw3'
        />
        <path
          style={{
            transformOrigin: '182.425px 309.015px'
          }}
          id='prefix__elwnx8qyawier'
          className='prefix__animable'
          fill='#ebebeb'
          d='M167.93 235.63h28.99V382.4h-28.99z'
        />
        <path
          style={{
            transformOrigin: '143.76px 228.335px'
          }}
          className='prefix__animable'
          fill='#f5f5f5'
          transform='rotate(180)'
          d='M119.59 221.04h48.34v14.59h-48.34z'
          id='prefix__elbjydss4so7q'
        />
        <path
          style={{
            transformOrigin: '143.76px 233.99px'
          }}
          className='prefix__animable'
          fill='#ebebeb'
          transform='rotate(180)'
          d='M119.59 232.35h48.34v3.28h-48.34z'
          id='prefix__elx5r1sy3imol'
        />
        <path
          style={{
            transformOrigin: '178.665px 228.335px'
          }}
          id='prefix__elbjaun4abskw'
          className='prefix__animable'
          fill='#ebebeb'
          d='M167.93 221.04h21.47v14.59h-21.47z'
        />
        <path
          style={{
            transformOrigin: '147.52px 213.745px'
          }}
          className='prefix__animable'
          fill='#f5f5f5'
          transform='rotate(180)'
          d='M127.11 206.45h40.82v14.59h-40.82z'
          id='prefix__eluzifnkyovs'
        />
        <path
          style={{
            transformOrigin: '147.52px 219.4px'
          }}
          className='prefix__animable'
          fill='#ebebeb'
          transform='rotate(180)'
          d='M127.11 217.76h40.82v3.28h-40.82z'
          id='prefix__eltkdbox642qs'
        />
        <path
          style={{
            transformOrigin: '174.91px 213.745px'
          }}
          id='prefix__elpgt29plnu48'
          className='prefix__animable'
          fill='#ebebeb'
          d='M167.93 206.45h13.96v14.59h-13.96z'
        />
        <path
          style={{
            transformOrigin: '154.495px 196.265px'
          }}
          id='prefix__el9maqf64uzvp'
          className='prefix__animable'
          fill='#ebebeb'
          d='M153.14 186.07h2.71v20.39h-2.71z'
        />
        <path
          style={{
            transformOrigin: '208.055px 321.775px'
          }}
          className='prefix__animable'
          fill='#f5f5f5'
          transform='rotate(180)'
          d='M187.66 261.15h40.79V382.4h-40.79z'
          id='prefix__elrbj8p7lsg1'
        />
        <path
          style={{
            transformOrigin: '239.035px 321.775px'
          }}
          id='prefix__elibt79nl1m6b'
          className='prefix__animable'
          fill='#ebebeb'
          d='M228.45 261.15h21.17V382.4h-21.17z'
        />
        <path
          style={{
            transformOrigin: '254.495px 339.095px'
          }}
          id='prefix__elpzob3i7un9n'
          className='prefix__animable'
          fill='#f5f5f5'
          d='M239.03 295.79l30.93 26.52v60.09h-30.93v-86.61z'
        />
        <path
          style={{
            transformOrigin: '277.995px 352.345px'
          }}
          id='prefix__elqj0egzd5n4'
          className='prefix__animable'
          fill='#ebebeb'
          d='M269.97 322.3h16.05v60.09h-16.05z'
        />
        <path
          style={{
            transformOrigin: '262.525px 309.05px'
          }}
          id='prefix__elu3hy57ypodh'
          className='prefix__animable'
          fill='#ebebeb'
          d='M286.02 322.31h-16.06l-30.93-26.52h16.06l30.93 26.52z'
        />
        <path
          d='M431 382.4a14.68 14.68 0 018.71-10.93 18.39 18.39 0 00-2.56 10.93z'
          style={{
            transformOrigin: '435.355px 376.935px'
          }}
          id='prefix__ell88li8pizx'
          className='prefix__animable'
          fill='#ebebeb'
        />
        <path
          d='M142.53 382.4a14.68 14.68 0 00-8.71-10.93 18.39 18.39 0 012.56 10.93z'
          style={{
            transformOrigin: '138.175px 376.935px'
          }}
          id='prefix__elrfwvypq1md8'
          className='prefix__animable'
          fill='#ebebeb'
        />
        <path
          d='M71.11 382.4s-.49-12.8-5.84-16.52C67.46 371.11 67 382.4 67 382.4z'
          style={{
            transformOrigin: '68.19px 374.14px'
          }}
          id='prefix__el9239o8ee00n'
          className='prefix__animable'
          fill='#ebebeb'
        />
        <path
          d='M69.1 382.4s.49-7.35 5.84-9.48c-2.19 3-1.71 9.48-1.71 9.48z'
          style={{
            transformOrigin: '72.02px 377.66px'
          }}
          id='prefix__eln9u8xadxzha'
          className='prefix__animable'
          fill='#ebebeb'
        />
        <path
          d='M147.11 382.4s-.54-12.12-10.24-16.52c4.34 6.22 4.09 16.52 4.09 16.52z'
          style={{
            transformOrigin: '141.99px 374.14px'
          }}
          id='prefix__eleg07lyst6mf'
          className='prefix__animable'
          fill='#ebebeb'
        />
        <path
          d='M386.29 366h-24.51a1 1 0 01-1-1v-24.48a1 1 0 011-1h24.51a1 1 0 011 1V365a1 1 0 01-1 1zm-23.51-2h22.51v-22.48h-22.51z'
          style={{
            transformOrigin: '374.035px 352.76px'
          }}
          id='prefix__elfw3seh7g3uo'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 341.52h-24.51a1 1 0 01-1-1V316a1 1 0 011-1h24.51a1 1 0 011 1v24.52a1 1 0 01-1 1zm-23.51-2h22.51V317h-22.51z'
          style={{
            transformOrigin: '374.035px 328.26px'
          }}
          id='prefix__eltjuwfchzrib'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 366a1 1 0 01-.7-.3l-24.52-24.51a1 1 0 111.42-1.42L387 364.33a1 1 0 010 1.41 1 1 0 01-.71.26z'
          style={{
            transformOrigin: '374.033px 352.738px'
          }}
          id='prefix__elka3n8zjzzo'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 341.52a1 1 0 01-.7-.29l-24.52-24.52a1 1 0 010-1.41 1 1 0 011.42 0L387 339.81a1 1 0 01-.71 1.71z'
          style={{
            transformOrigin: '374.038px 328.262px'
          }}
          id='prefix__elog4rp9ri4ql'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 317h-24.51a1 1 0 01-1-1v-24.51a1 1 0 011-1h24.51a1 1 0 011 1V316a1 1 0 01-1 1zm-23.51-2h22.51v-22.51h-22.51z'
          style={{
            transformOrigin: '374.035px 303.745px'
          }}
          id='prefix__el6mzqyh2buve'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 292.49h-24.51a1 1 0 01-1-1V267a1 1 0 011-1h24.51a1 1 0 011 1v24.52a1 1 0 01-1 .97zm-23.51-2h22.51V268h-22.51z'
          style={{
            transformOrigin: '374.035px 279.245px'
          }}
          id='prefix__el52yoru8vds9'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 317a1 1 0 01-.7-.29l-24.52-24.52a1 1 0 010-1.41 1 1 0 011.42 0L387 315.3a1 1 0 010 1.41 1 1 0 01-.71.29z'
          style={{
            transformOrigin: '374.035px 303.742px'
          }}
          id='prefix__el15dnm1tcpvmi'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 292.49a1 1 0 01-.7-.3l-24.52-24.51a1 1 0 011.42-1.42L387 290.78a1 1 0 010 1.41 1 1 0 01-.71.3z'
          style={{
            transformOrigin: '374.033px 279.228px'
          }}
          id='prefix__el0l1q3b7835a'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 268h-24.51a1 1 0 01-1-1v-24.55a1 1 0 011-1h24.51a1 1 0 011 1V267a1 1 0 01-1 1zm-23.51-2h22.51v-22.55h-22.51z'
          style={{
            transformOrigin: '374.035px 254.725px'
          }}
          id='prefix__eld3o9itgcnuj'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 243.45h-24.51a1 1 0 01-1-1v-24.51a1 1 0 011-1h24.51a1 1 0 011 1v24.51a1 1 0 01-1 1zm-23.51-2h22.51v-22.51h-22.51z'
          style={{
            transformOrigin: '374.035px 230.195px'
          }}
          id='prefix__elm4ywpfuozl8'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 268a1 1 0 01-.7-.29l-24.52-24.52a1 1 0 010-1.41 1 1 0 011.42 0L387 266.26a1 1 0 01-.71 1.71z'
          style={{
            transformOrigin: '374.038px 254.742px'
          }}
          id='prefix__elyo6fc9mvy8c'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M361.78 161.55h-24.52a1 1 0 01-1-1V136a1 1 0 011-1h24.52a1 1 0 011 1v24.51a1 1 0 01-1 1.04zm-23.52-2h22.52V137h-22.52z'
          style={{
            transformOrigin: '349.52px 148.275px'
          }}
          id='prefix__elyirdav8d2n'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 161.55h-24.51a1 1 0 010-2h23.51v-48a1 1 0 112 0v49a1 1 0 01-1 1z'
          style={{
            transformOrigin: '374.035px 136.05px'
          }}
          id='prefix__elt8h7solocvr'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M361.78 161.55a1 1 0 01-.9-1.45l24.52-49a1 1 0 011.34-.44 1 1 0 01.45 1.34l-24.52 49a1 1 0 01-.89.55z'
          style={{
            transformOrigin: '374.034px 136.052px'
          }}
          id='prefix__el8bwpdwa2dlp'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M337.26 161.55h-24.51a1 1 0 01-1-1V136a1 1 0 011-1h24.51a1 1 0 011 1v24.51a1 1 0 01-1 1.04zm-23.51-2h22.51V137h-22.51z'
          style={{
            transformOrigin: '325.005px 148.275px'
          }}
          id='prefix__elp39jdspzce'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M337.26 161.55a1 1 0 01-.7-1.7l24.51-24.52a1 1 0 011.42 0 1 1 0 010 1.41L338 161.26a1 1 0 01-.74.29z'
          style={{
            transformOrigin: '349.527px 148.292px'
          }}
          id='prefix__elz4utkb0t33'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M410.81 161.55h-24.52a1 1 0 01-1-1V136a1 1 0 011-1h24.52a1 1 0 011 1v24.51a1 1 0 01-1 1.04zm-23.52-2h22.52V137h-22.52z'
          style={{
            transformOrigin: '398.55px 148.275px'
          }}
          id='prefix__elqv694ww6blo'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 161.55a1 1 0 01-.7-1.7l24.51-24.52a1 1 0 011.42 0 1 1 0 010 1.41L387 161.26a1 1 0 01-.71.29z'
          style={{
            transformOrigin: '398.557px 148.292px'
          }}
          id='prefix__elvzaflotk45'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M239.2 161.55a1 1 0 01-.71-.29 1 1 0 010-1.41L263 135.33a.91.91 0 01.51-.27l122.59-24.52a1 1 0 01.9.27l49 49a1 1 0 11-1.41 1.41L386 112.61 264.21 137l-24.31 24.3a1 1 0 01-.7.25z'
          style={{
            transformOrigin: '337.274px 136.045px'
          }}
          id='prefix__el1pv2w1o2y87j'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M312.75 161.55a1 1 0 01-.71-.29 1 1 0 010-1.41l24.52-24.52a1 1 0 011.41 1.41l-24.52 24.52a1 1 0 01-.7.29z'
          style={{
            transformOrigin: '324.98px 148.32px'
          }}
          id='prefix__elqkorhe819bf'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M312.75 161.55h-24.52a1 1 0 01-1-1V136a1 1 0 011-1h24.52a1 1 0 011 1v24.51a1 1 0 01-1 1.04zm-23.52-2h22.52V137h-22.52z'
          style={{
            transformOrigin: '300.49px 148.275px'
          }}
          id='prefix__elscllj907wt'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M288.23 161.55h-24.52a1 1 0 01-1-1V136a1 1 0 011-1h24.52a1 1 0 011 1v24.51a1 1 0 01-1 1.04zm-23.52-2h22.52V137h-22.52z'
          style={{
            transformOrigin: '275.97px 148.275px'
          }}
          id='prefix__elb2lnakiwmqo'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M288.23 161.55a1 1 0 01-.71-.29 1 1 0 010-1.41L312 135.33a1 1 0 011.41 1.41l-24.51 24.52a1 1 0 01-.67.29z'
          style={{
            transformOrigin: '300.44px 148.32px'
          }}
          id='prefix__eldkomi5k1r6m'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M263.71 161.55a1 1 0 01-.7-1.7l24.51-24.52a1 1 0 011.42 0 1 1 0 010 1.41l-24.52 24.52a1 1 0 01-.71.29z'
          style={{
            transformOrigin: '275.977px 148.292px'
          }}
          id='prefix__elhsedyb6drrg'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M263.71 161.55H239.2a1 1 0 010-2h23.51V136a1 1 0 012 0v24.51a1 1 0 01-1 1.04z'
          style={{
            transformOrigin: '251.455px 148.275px'
          }}
          id='prefix__elbkbfeiaai86'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 243.45a1 1 0 01-.7-.29l-24.52-24.51a1 1 0 111.42-1.42L387 241.75a1 1 0 010 1.41 1 1 0 01-.71.29z'
          style={{
            transformOrigin: '374.033px 230.193px'
          }}
          id='prefix__el5srhykm9tvf'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 218.94h-24.51a1 1 0 01-1-1v-24.52a1 1 0 011-1h24.51a1 1 0 011 1v24.52a1 1 0 01-1 1zm-23.51-2h22.51v-22.52h-22.51z'
          style={{
            transformOrigin: '374.035px 205.68px'
          }}
          id='prefix__elkm90y94pzv'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 194.42h-24.51a1 1 0 01-1-1v-24.51a1 1 0 011-1h24.51a1 1 0 011 1v24.51a1 1 0 01-1 1zm-23.51-2h22.51v-22.51h-22.51z'
          style={{
            transformOrigin: '374.035px 181.165px'
          }}
          id='prefix__elp80b2hab3wb'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 218.94a1 1 0 01-.7-.29l-24.52-24.52a1 1 0 111.42-1.42L387 217.23a1 1 0 01-.71 1.71z'
          style={{
            transformOrigin: '374.036px 205.678px'
          }}
          id='prefix__eldck0caikl4p'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M386.29 194.42a1 1 0 01-.7-.29l-24.52-24.52a1 1 0 010-1.41 1 1 0 011.42 0L387 192.71a1 1 0 01-.71 1.71z'
          style={{
            transformOrigin: '374.038px 181.162px'
          }}
          id='prefix__el87qzvhkmk0o'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          style={{
            transformOrigin: '337.265px 164.73px'
          }}
          id='prefix__elhrh5yn9nr48'
          className='prefix__animable'
          fill='#e0e0e0'
          d='M435.33 160.55H239.2l24.51 8.36h171.62v-8.36z'
        />
        <path
          d='M435.33 169.91H263.71a.91.91 0 01-.32-.06l-24.52-8.35a1 1 0 01.33-1.95h196.13a1 1 0 011 1v8.36a1 1 0 01-1 1zm-171.45-2h170.45v-6.36h-189.1z'
          style={{
            transformOrigin: '337.256px 164.73px'
          }}
          id='prefix__elsrel6rq54ap'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          style={{
            transformOrigin: '352.705px 184.015px'
          }}
          className='prefix__animable'
          fill='#e0e0e0'
          transform='rotate(180)'
          d='M343.63 164.73h18.15v38.57h-18.15z'
          id='prefix__elie6dylng09e'
        />
        <path
          style={{
            transformOrigin: '339.4px 184.015px'
          }}
          id='prefix__elfp75ldac8ba'
          className='prefix__animable'
          fill='#f5f5f5'
          d='M335.18 164.73h8.44v38.57h-8.44z'
        />
        <path
          style={{
            transformOrigin: '382.35px 373.72px'
          }}
          className='prefix__animable'
          fill='#e0e0e0'
          transform='rotate(180)'
          d='M364.48 365.04h35.74v17.36h-35.74z'
          id='prefix__elm5t02a59lk'
        />
        <path
          style={{
            transformOrigin: '356.165px 373.72px'
          }}
          id='prefix__el63it92wruxd'
          className='prefix__animable'
          fill='#f5f5f5'
          d='M347.85 365.04h16.63v17.36h-16.63z'
        />
        <path
          d='M410.81 203.64a1 1 0 01-1-1v-37.91a1 1 0 112 0v37.91a1 1 0 01-1 1z'
          style={{
            transformOrigin: '410.81px 183.685px'
          }}
          id='prefix__elotgllp4ufl'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M410.81 208.24a3.3 3.3 0 113.3-3.3 3.3 3.3 0 01-3.3 3.3zm0-4.6a1.3 1.3 0 101.3 1.3 1.3 1.3 0 00-1.3-1.3z'
          style={{
            transformOrigin: '410.81px 204.94px'
          }}
          id='prefix__eloo6diiuzxhf'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M266.79 223.54a1 1 0 01-1-1v-57.81a1 1 0 112 0v57.81a1 1 0 01-1 1z'
          style={{
            transformOrigin: '266.79px 193.635px'
          }}
          id='prefix__elr7an8knuzx'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M276.18 229.53a1 1 0 01-1-.83c-.74-1.16-7.25-5-8.44-5.16-1.12.15-7.63 4-8.37 5.16a1 1 0 01-2-.17c0-2.25 9.07-7 10.38-7s10.39 4.74 10.39 7a1 1 0 01-.96 1z'
          style={{
            transformOrigin: '266.753px 225.572px'
          }}
          id='prefix__elbem2urcp0g7'
          className='prefix__animable'
          fill='#e0e0e0'
        />
        <path
          d='M287 301.81l14.67-14.67-3.13-6c.27-.6.52-1.2.75-1.82l6.43-2V256.6l-6.43-2c-.24-.61-.48-1.22-.75-1.82l3.12-6L287 232.14l-6 3.12c-.6-.27-1.2-.52-1.81-.75l-2-6.43h-20.77l-2 6.43c-.61.23-1.21.48-1.81.75l-6-3.12L232 246.8l3.13 6c-.28.6-.52 1.21-.76 1.82l-6.43 2v20.74l6.43 2c.24.62.48 1.22.75 1.82l-3.12 6 14.67 14.67 6-3.13c.6.27 1.21.52 1.82.75l2 6.43h20.75l2-6.43c.61-.23 1.21-.48 1.81-.75zm-9.25-23.93a15.44 15.44 0 110-21.83 15.42 15.42 0 01-.04 21.83z'
          style={{
            transformOrigin: '266.83px 266.99px'
          }}
          id='prefix__elubd1xjs7fq'
          className='prefix__animable'
          fill='#e0e0e0'
        />
      </g>
      <g
        id='prefix__freepik--Shadow--inject-80'
        className='prefix__animable'
        style={{
          transformOrigin: '250px 416.24px',
          animation: '1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown',
          animationDelay: '0s'
        }}
      >
        <ellipse
          cx={250}
          cy={416.24}
          rx={193.89}
          ry={11.32}
          style={{
            transformOrigin: '250px 416.24px'
          }}
          id='prefix__el35o8vfi1hxx'
          className='prefix__animable'
          fill='#f5f5f5'
        />
      </g>
      <g
        id='prefix__freepik--Gear--inject-80'
        className='prefix__animable'
        style={{
          transformOrigin: '169.65px 177.205px',
          animation: '1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomOut',
          animationDelay: '0s'
        }}
      >
        <path
          d='M175.89 163.15h-12.48a3.27 3.27 0 00-2.82 1.62l-6.24 10.81a3.27 3.27 0 000 3.26l6.24 10.8a3.25 3.25 0 002.82 1.63h12.48a3.25 3.25 0 002.82-1.63l6.24-10.8a3.27 3.27 0 000-3.26l-6.24-10.81a3.27 3.27 0 00-2.82-1.62z'
          style={{
            transformOrigin: '169.65px 177.21px'
          }}
          id='prefix__el6v36kbmxnzo'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M175.89 163.15h-12.48a3.27 3.27 0 00-2.82 1.62l-6.24 10.81a3.27 3.27 0 000 3.26l6.24 10.8a3.25 3.25 0 002.82 1.63h12.48a3.25 3.25 0 002.82-1.63l6.24-10.8a3.27 3.27 0 000-3.26l-6.24-10.81a3.27 3.27 0 00-2.82-1.62z'
          style={{
            transformOrigin: '169.65px 177.21px'
          }}
          className='prefix__animable'
          fill='#fff'
          opacity={0.5}
          id='prefix__eleeoj7zugysv'
        />
        <path
          d='M96 127.33l-.71-.71 6-6 .71.71zM106.33 117l-.71-.71 12.54-12.54.71.7z'
          style={{
            transformOrigin: '107.08px 115.54px'
          }}
          id='prefix__elbbng2w4nbhr'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M96 127.33l-.71-.71 6-6 .71.71zM106.33 117l-.71-.71 12.54-12.54.71.7z'
          style={{
            transformOrigin: '107.08px 115.54px'
          }}
          className='prefix__animable'
          fill='#fff'
          opacity={0.5}
          id='prefix__elenxm641tx1i'
        />
        <path
          d='M254.5 199.84v-45.26l-14-4.39c-.5-1.34-1.05-2.66-1.63-4l6.81-13-32-32-13 6.82c-1.31-.59-2.62-1.14-4-1.65l-4.39-14H147l-4.38 14c-1.35.51-2.66 1.06-4 1.65l-13-6.82-32 32 6.82 13c-.59 1.31-1.14 2.62-1.64 4l-14 4.39v45.26l14 4.38c.51 1.34 1.06 2.66 1.64 4l-6.82 13 32 32 13-6.82c1.3.59 2.61 1.14 4 1.65l4.38 14h45.26l4.39-14c1.34-.51 2.65-1.06 4-1.65l13 6.82 32-32-6.82-13c.58-1.3 1.14-2.62 1.64-4zm-51.17-22.64a33.68 33.68 0 11-33.68-33.68 33.69 33.69 0 0133.68 33.68z'
          style={{
            transformOrigin: '169.65px 177.205px'
          }}
          id='prefix__ele9m3mxwo0s8'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M254.5 199.84v-45.26l-14-4.39c-.5-1.34-1.05-2.66-1.63-4l6.81-13-32-32-13 6.82c-1.31-.59-2.62-1.14-4-1.65l-4.39-14H147l-4.38 14c-1.35.51-2.66 1.06-4 1.65l-13-6.82-32 32 6.82 13c-.59 1.31-1.14 2.62-1.64 4l-14 4.39v45.26l14 4.38c.51 1.34 1.06 2.66 1.64 4l-6.82 13 32 32 13-6.82c1.3.59 2.61 1.14 4 1.65l4.38 14h45.26l4.39-14c1.34-.51 2.65-1.06 4-1.65l13 6.82 32-32-6.82-13c.58-1.3 1.14-2.62 1.64-4zm-51.17-22.64a33.68 33.68 0 11-33.68-33.68 33.69 33.69 0 0133.68 33.68z'
          style={{
            transformOrigin: '169.65px 177.205px'
          }}
          className='prefix__animable'
          fill='#fff'
          opacity={0.5}
          id='prefix__elyny9rhioar9'
        />
        <path
          d='M190.08 259.31h-40.85a.25.25 0 01-.24-.18l-4-12.62a.25.25 0 01.48-.15l3.89 12.45h40.48l4.16-13.14a.26.26 0 01.15-.16l1.37-.51c1.16-.44 2.39-.95 3.78-1.57l1.33-.6a.25.25 0 01.2.46l-1.33.59a64.63 64.63 0 01-3.8 1.58l-1.26.48-4.12 13.19a.26.26 0 01-.24.18zm23-9.53a.29.29 0 01-.18-.07.25.25 0 010-.36l28.76-28.75-6.39-12.2a.24.24 0 010-.22l.6-1.33c.6-1.35 1.11-2.59 1.56-3.77l.51-1.37a.26.26 0 01.16-.15l13.15-4.11V157l-13-4.06a.25.25 0 11.15-.47l13.14 4.1a.26.26 0 01.17.24v40.85a.25.25 0 01-.17.24l-13.17 4.1-.47 1.26c-.45 1.19-1 2.43-1.58 3.8l-.54 1.22 6.41 12.25a.24.24 0 010 .29l-28.88 28.89a.31.31 0 01-.22.07zm-86.87 0a.29.29 0 01-.18-.07l-28.88-28.89a.26.26 0 010-.29l6.47-12.36a.26.26 0 01.34-.11.25.25 0 01.1.34l-6.38 12.2 28.75 28.75a.25.25 0 010 .36.28.28 0 01-.21.07zm17-4.49h-.09c-1-.39-2.09-.85-3.3-1.39a.25.25 0 11.2-.45c1.2.53 2.27 1 3.28 1.37a.25.25 0 01.14.33.24.24 0 01-.25.14zm26.46-31.14a37 37 0 01-36.93-37 .25.25 0 01.5 0 36.43 36.43 0 1036.43-36.43.25.25 0 010-.5 36.94 36.94 0 010 73.88zm-68-10.73a.27.27 0 01-.24-.17l-.47-1.25-13.21-4.13a.25.25 0 01-.17-.24v-40.85a.26.26 0 01.17-.24l12.63-3.94a.26.26 0 01.32.16.27.27 0 01-.17.32L88.05 157v40.48l13.15 4.11a.23.23 0 01.15.15l.52 1.37a.25.25 0 01-.14.32zm0-52h-.09a.26.26 0 01-.14-.33c.48-1.28 1-2.5 1.55-3.74a.25.25 0 01.33-.12.25.25 0 01.13.33c-.56 1.22-1.06 2.44-1.54 3.71a.26.26 0 01-.26.18zm134.19-5.71h-.12a.25.25 0 01-.1-.34l6-11.55-4.8-4.82a.25.25 0 11.35-.35l5 5a.24.24 0 010 .29l-6.13 11.71a.25.25 0 01-.22.09zM97.33 134a.26.26 0 01-.18-.07.26.26 0 010-.35L126 104.71a.23.23 0 01.29 0l12.25 6.41 1.22-.54c1.18-.53 2.26-1 3.3-1.39a.25.25 0 01.33.14.25.25 0 01-.15.32c-1 .41-2.1.86-3.27 1.38l-1.33.6a.28.28 0 01-.22 0l-12.2-6.39L97.51 134a.24.24 0 01-.18 0zm135.52-9.12a.26.26 0 01-.18-.07L213 105.19l-12.2 6.39a.22.22 0 01-.21 0l-1.33-.6c-1.37-.61-2.61-1.12-3.78-1.57l-1.37-.51a.26.26 0 01-.15-.16l-4.11-13.14h-40.44l-3.54 11.31a.24.24 0 01-.31.16.25.25 0 01-.16-.31l3.6-11.48a.25.25 0 01.24-.17h40.85a.26.26 0 01.24.17l4.12 13.2 1.26.48c1.18.44 2.42 1 3.8 1.58l1.22.54 12.27-6.41a.24.24 0 01.29 0l19.71 19.8a.25.25 0 010 .36.26.26 0 01-.15.07z'
          style={{
            transformOrigin: '169.645px 177.21px'
          }}
          id='prefix__elz63m6ec8ll'
          className='prefix__animable'
          fill='#fafafa'
        />
      </g>
      <g
        id='prefix__freepik--Character--inject-80'
        className='prefix__animable'
        style={{
          transformOrigin: '270.695px 272.887px',
          animation: '1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft',
          animationDelay: '0s'
        }}
      >
        <path
          d='M313.34 185.39c3.13 4 6.06 8 8.92 12.13s5.58 8.35 8.15 12.75c.65 1.09 1.27 2.23 1.9 3.35a13.49 13.49 0 011.57 5.49 28.65 28.65 0 01-.84 8.67 61.61 61.61 0 01-5.62 14.61l-5.15-2a115.55 115.55 0 002.21-14 23.47 23.47 0 00-.2-6.1 3.71 3.71 0 00-.61-1.56c-.66-1-1.3-2-2-3-2.71-4-5.58-7.91-8.47-11.84l-8.69-11.78z'
          style={{
            transformOrigin: '319.217px 213.89px'
          }}
          id='prefix__elhmwxynbes3f'
          className='prefix__animable'
          fill='#ff8b7b'
        />
        <path
          d='M321.91 239.81l-2.66 4.76 9.28 1.37s1-4-1.33-6.76z'
          style={{
            transformOrigin: '323.997px 242.56px'
          }}
          id='prefix__elcmxys01dte6'
          className='prefix__animable'
          fill='#ff8b7b'
        />
        <path
          style={{
            transformOrigin: '323.19px 248.125px'
          }}
          id='prefix__elm0annyj8a1d'
          className='prefix__animable'
          fill='#ff8b7b'
          d='M317.85 250.9l7.73.78 2.95-5.74-9.28-1.37-1.4 6.33z'
        />
        <path
          d='M343 279.3l2.76-14.69a6.55 6.55 0 017.63-5.23l23.17 4.34a30.62 30.62 0 00-46.73-16.44l-105.12-62.22a30.62 30.62 0 00-54.71-21.3l23.17 4.34a6.57 6.57 0 015.22 7.64l-2.76 14.7a6.56 6.56 0 01-7.63 5.23l-23.17-4.35a30.62 30.62 0 0047 16.27l104.91 62.1a30.62 30.62 0 0054.66 21.6l-23.17-4.35a6.57 6.57 0 01-5.23-7.64z'
          style={{
            transformOrigin: '270.695px 227.508px'
          }}
          id='prefix__elmykdp0mwfu'
          className='prefix__animable'
          fill='#407bff'
        />
        <rect
          x={218.02}
          y={220.75}
          width={105.56}
          height={13.34}
          rx={3.26}
          style={{
            transformOrigin: '270.8px 227.42px'
          }}
          className='prefix__animable'
          fill='#407bff'
          transform='rotate(30.62)'
          id='prefix__elv4ds9t6s6hf'
        />
        <rect
          x={218.02}
          y={220.75}
          width={105.56}
          height={13.34}
          rx={3.26}
          style={{
            transformOrigin: '270.8px 227.42px'
          }}
          className='prefix__animable'
          fill='#fff'
          opacity={0.2}
          transform='rotate(30.62)'
          id='prefix__el0e4qyd00g2it'
        />
        <path
          d='M277.74 154.31c-.1.59-.48 1-.86 1s-.62-.59-.53-1.17.48-1 .86-.95.62.54.53 1.12z'
          style={{
            transformOrigin: '277.045px 154.248px'
          }}
          id='prefix__el61jdruwzns7'
          className='prefix__animable'
          fill='#263238'
        />
        <path
          d='M277.31 155.33a21.22 21.22 0 01-3.58 4.57 3.44 3.44 0 002.72 1z'
          style={{
            transformOrigin: '275.52px 158.121px'
          }}
          id='prefix__el1izr0ftugjd'
          className='prefix__animable'
          fill='#ff5652'
        />
        <path
          d='M280.37 151.4a.33.33 0 01-.24-.1 2.75 2.75 0 00-2.37-.83.35.35 0 01-.42-.27.34.34 0 01.27-.41 3.43 3.43 0 013 1 .37.37 0 010 .5.39.39 0 01-.24.11z'
          style={{
            transformOrigin: '279.019px 150.574px'
          }}
          id='prefix__el1b26tlywogn'
          className='prefix__animable'
          fill='#263238'
        />
        <path
          d='M297.27 160.76c-1 5.38-2.1 15.23 1.66 18.81 0 0-1.47 5.45-11.46 5.45-11 0-5.25-5.45-5.25-5.45 6-1.43 5.84-5.88 4.8-10z'
          style={{
            transformOrigin: '289.824px 172.89px'
          }}
          id='prefix__el5adkibsp9x4'
          className='prefix__animable'
          fill='#ff8b7b'
        />
        <path
          d='M304 183.61a1.93 1.93 0 01-.27-.58c-.84-3.19-4.37-5.68-8.95-5.81-4.83-.12-10.28.46-13.5 3.12-1.42 1.17.15 2.88.15 2.88z'
          style={{
            transformOrigin: '292.343px 180.408px'
          }}
          id='prefix__eloil201r30h'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M304 183.61a1.93 1.93 0 01-.27-.58c-.84-3.19-4.37-5.68-8.95-5.81-4.83-.12-10.28.46-13.5 3.12-1.42 1.17.15 2.88.15 2.88z'
          style={{
            transformOrigin: '292.343px 180.408px'
          }}
          className='prefix__animable'
          fill='#fff'
          opacity={0.5}
          id='prefix__elbhyyvtpimsu'
        />
        <path
          d='M339.31 384.83h-.07a.71.71 0 01-.6-.57.82.82 0 01.09-.68c.56-.95 3-1.45 3.07-1.47a.18.18 0 01.18.07.19.19 0 010 .19c-.37.63-1.74 2.46-2.67 2.46zm2.15-2.29c-.8.21-2.1.64-2.43 1.21a.42.42 0 000 .39c.09.31.25.33.29.34.45.06 1.51-1.02 2.14-1.94z'
          style={{
            transformOrigin: '340.304px 383.468px'
          }}
          id='prefix__eldjwawc1bru'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M340.64 382.58c-.91 0-1.93-.17-2.24-.61a.58.58 0 01.06-.72 1 1 0 01.67-.38c1.1-.12 2.75 1.21 2.82 1.27a.17.17 0 01-.06.3 4.63 4.63 0 01-1.25.14zm-1.34-1.37h-.13a.57.57 0 00-.43.24c-.14.18-.08.27-.05.3.28.41 1.81.57 2.74.42a4.63 4.63 0 00-2.13-.96z'
          style={{
            transformOrigin: '340.16px 381.722px'
          }}
          id='prefix__elf3mxiqsntpm'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M266.68 409.11c-.94 0-1.85-.13-2.16-.55a.66.66 0 010-.76.89.89 0 01.56-.41c1.22-.33 3.79 1.13 3.9 1.2a.17.17 0 01.08.18.18.18 0 01-.14.14 13.29 13.29 0 01-2.24.2zm-1.17-1.42a1.15 1.15 0 00-.33 0 .51.51 0 00-.34.24c-.13.22-.08.33 0 .39.34.47 2.2.48 3.57.29a7.87 7.87 0 00-2.9-.92z'
          style={{
            transformOrigin: '266.731px 408.226px'
          }}
          id='prefix__eluunk1cz11ir'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M268.9 408.91h-.07c-.89-.4-2.65-2-2.51-2.82 0-.2.17-.44.65-.49a1.3 1.3 0 011 .3c.94.77 1.13 2.75 1.14 2.83a.17.17 0 01-.07.16.19.19 0 01-.14.02zm-1.79-3H267c-.31 0-.33.15-.34.19-.08.5 1.12 1.75 2 2.29a4.08 4.08 0 00-1-2.26.92.92 0 00-.55-.2z'
          style={{
            transformOrigin: '267.712px 407.253px'
          }}
          id='prefix__elot7gmkamdgs'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          style={{
            transformOrigin: '272.94px 400.235px'
          }}
          id='prefix__eljexm86g5qld'
          className='prefix__animable'
          fill='#ff8b7b'
          d='M276.98 408.74h-7.35l-.73-17.01h7.35l.73 17.01z'
        />
        <path
          style={{
            transformOrigin: '338.4px 373.785px'
          }}
          id='prefix__elxxyxy4beupm'
          className='prefix__animable'
          fill='#ff8b7b'
          d='M348.41 377.05l-5.96 4.3-14.06-10.84 5.96-4.29 14.06 10.83z'
        />
        <path
          d='M341.6 381.29l5.72-6a.63.63 0 01.79-.1l5.72 3.47a1.09 1.09 0 01.2 1.68c-2 2.05-3.13 2.94-5.64 5.56-1.55 1.61-5.75 7.27-7.89 9.5s-4.61.4-3.94-.7c3-4.94 4.46-9.84 4.54-12.28a1.81 1.81 0 01.5-1.13z'
          style={{
            transformOrigin: '345.393px 385.775px'
          }}
          id='prefix__elzk95hmv6phq'
          className='prefix__animable'
          fill='#263238'
        />
        <path
          d='M269.68 407.89h8a.64.64 0 01.63.5l1.45 6.53a1.07 1.07 0 01-1.06 1.3c-2.89 0-7.07-.21-10.71-.21-4.26 0-7.93.23-12.92.23-3 0-3.85-3.05-2.59-3.33 5.75-1.25 10.44-1.39 15.41-4.45a3.41 3.41 0 011.79-.57z'
          style={{
            transformOrigin: '265.851px 412.065px'
          }}
          id='prefix__elco0u90wleyh'
          className='prefix__animable'
          fill='#263238'
        />
        <path
          d='M303.06 195.08c1 1.85 2.13 3.64 3.22 5.31 1.88 2.89 3.7 5.39 5 7.11 1.17 1.55 1.92 2.46 1.92 2.46l14.8-10.09s-9-17.52-15.93-18.64c-7.13-1.13-13.66 5.55-9.01 13.85z'
          style={{
            transformOrigin: '314.748px 195.532px'
          }}
          id='prefix__el665hfpuln85'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M303.06 195.08c1 1.85 2.13 3.64 3.22 5.31 1.88 2.89 3.7 5.39 5 7.11 1.17 1.55 1.92 2.46 1.92 2.46l14.8-10.09s-9-17.52-15.93-18.64c-7.13-1.13-13.66 5.55-9.01 13.85z'
          style={{
            transformOrigin: '314.748px 195.532px'
          }}
          className='prefix__animable'
          opacity={0.5}
          id='prefix__elq3fcj0xzksh'
        />
        <path
          d='M306.28 200.39c1.88 2.89 3.7 5.39 5 7.11-.15-3.44-.86-9-3.53-13.24-.97.96-1.36 3.44-1.47 6.13z'
          style={{
            transformOrigin: '308.78px 200.88px'
          }}
          id='prefix__elpqbo94qr9p'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M306.28 200.39c1.88 2.89 3.7 5.39 5 7.11-.15-3.44-.86-9-3.53-13.24-.97.96-1.36 3.44-1.47 6.13z'
          style={{
            transformOrigin: '308.78px 200.88px'
          }}
          className='prefix__animable'
          opacity={0.6}
          id='prefix__elkq79gs7b6sj'
        />
        <path
          d='M267.31 205.56c0 2.5.06 5.25.2 8.28.36 8.24 1.26 18.51 3 31.27h39.29c.27-6-3.52-35.46 2.3-63.88a102.86 102.86 0 00-13.16-1.66 145.27 145.27 0 00-16.7 0 74.93 74.93 0 00-11.3 2s-3.64 4.13-3.63 23.99z'
          style={{
            transformOrigin: '289.705px 212.22px'
          }}
          id='prefix__elpg8dlhnuvpa'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M267.31 205.56c0 2.5.06 5.25.2 8.28.36 8.24 1.26 18.51 3 31.27h39.29c.27-6-3.52-35.46 2.3-63.88a102.86 102.86 0 00-13.16-1.66 145.27 145.27 0 00-16.7 0 74.93 74.93 0 00-11.3 2s-3.64 4.13-3.63 23.99z'
          style={{
            transformOrigin: '289.705px 212.22px'
          }}
          className='prefix__animable'
          opacity={0.5}
          id='prefix__el5ud73yc2q8a'
        />
        <path
          d='M267.31 205.56c0 2.5.06 5.25.2 8.28 4.61-4.5 4.92-13.69 4.92-13.69z'
          style={{
            transformOrigin: '269.87px 206.995px'
          }}
          id='prefix__elzyoejltma5n'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M267.31 205.56c0 2.5.06 5.25.2 8.28 4.61-4.5 4.92-13.69 4.92-13.69z'
          style={{
            transformOrigin: '269.87px 206.995px'
          }}
          className='prefix__animable'
          opacity={0.6}
          id='prefix__ely0hvpnn9ef'
        />
        <path
          d='M275.5 194.15a35 35 0 01-2.5 3.64c-.83 1.08-1.66 2.1-2.51 3.11-1.69 2-3.5 3.93-5.34 5.8a74.19 74.19 0 01-12.45 10.16 40.75 40.75 0 01-3.75 2.08l-.51.24-.25.12-.31.13a11.41 11.41 0 01-1.52.52l-.73.19-.7.12a11.14 11.14 0 01-1.35.15 26.08 26.08 0 01-8.88-1.25 58.53 58.53 0 01-14.35-6.71l2.37-5a106.47 106.47 0 0013.87 3.16 19.68 19.68 0 006 .08 2.78 2.78 0 00.5-.13l.22-.06.16-.07c.13 0 .16-.1.24-.13l.6-.35a29.76 29.76 0 002.67-1.75 76.29 76.29 0 0010.25-9.28c1.63-1.71 3.2-3.5 4.73-5.28.76-.9 1.5-1.8 2.19-2.71s1.4-1.84 1.81-2.48z'
          style={{
            transformOrigin: '247.925px 204.437px'
          }}
          id='prefix__el0hbbpwjxa9kq'
          className='prefix__animable'
          fill='#ff8b7b'
        />
        <path
          d='M223.8 208.8l-4.88-5.8-3.32 8.48s4.21 2 7.49.84z'
          style={{
            transformOrigin: '219.7px 207.841px'
          }}
          id='prefix__elhlzhml12ne8'
          className='prefix__animable'
          fill='#ff8b7b'
        />
        <path
          style={{
            transformOrigin: '214.66px 206.6px'
          }}
          id='prefix__elpurw3i6kivq'
          className='prefix__animable'
          fill='#ff8b7b'
          d='M211.76 201.73l-1.36 6.77 5.2 2.97 3.32-8.48-7.16-1.26z'
        />
        <path
          d='M281.39 190.17c-.87 7-16.75 21.75-16.75 21.75l-14.3-11.34a82.57 82.57 0 0112.52-14.53c10.36-8.98 19.58-4.24 18.53 4.12z'
          style={{
            transformOrigin: '265.906px 196.561px'
          }}
          id='prefix__elz84lwa4hf8j'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M281.39 190.17c-.87 7-16.75 21.75-16.75 21.75l-14.3-11.34a82.57 82.57 0 0112.52-14.53c10.36-8.98 19.58-4.24 18.53 4.12z'
          style={{
            transformOrigin: '265.906px 196.561px'
          }}
          className='prefix__animable'
          opacity={0.5}
          id='prefix__el556hd584t7i'
        />
        <path
          d='M269 237.42c14.27 0 17.53-16.14 18.28-23.07a87.14 87.14 0 00-12.27-33 .89.89 0 01.59-1.35l3.13-.58a.93.93 0 01.93.41c8.59 13.75 11.4 25.41 12.31 31.41h2.56c2.62-5.7 8.39-18.69 7.92-30.86a.88.88 0 011-.93l3.36.33a.88.88 0 01.82.84c.49 11.73-6.14 28-8.69 33.17.87 19.14 11.52 22.45 11.52 22.45a72 72 0 01-.63 14.25c-22.55 3.66-33.79 1.43-40.22-1.23.5-4.81-.4-8.18-.61-11.84z'
          style={{
            transformOrigin: '289.785px 215.909px'
          }}
          id='prefix__ela4k1efa8uo9'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M269 237.42c14.27 0 17.53-16.14 18.28-23.07a87.14 87.14 0 00-12.27-33 .89.89 0 01.59-1.35l3.13-.58a.93.93 0 01.93.41c8.59 13.75 11.4 25.41 12.31 31.41h2.56c2.62-5.7 8.39-18.69 7.92-30.86a.88.88 0 011-.93l3.36.33a.88.88 0 01.82.84c.49 11.73-6.14 28-8.69 33.17.87 19.14 11.52 22.45 11.52 22.45a72 72 0 01-.63 14.25c-22.55 3.66-33.79 1.43-40.22-1.23.5-4.81-.4-8.18-.61-11.84z'
          style={{
            transformOrigin: '289.785px 215.909px'
          }}
          className='prefix__animable'
          opacity={0.3}
          id='prefix__el4iwjdpxkgoc'
        />
        <path
          style={{
            transformOrigin: '272.765px 396.115px'
          }}
          id='prefix__elha4msq1qwvi'
          className='prefix__animable'
          fill='#ff5652'
          d='M268.9 391.73l.38 8.77h7.35l-.38-8.77h-7.35z'
        />
        <path
          style={{
            transformOrigin: '335.005px 371.16px'
          }}
          id='prefix__elnxjkxj3sn1'
          className='prefix__animable'
          fill='#ff5652'
          d='M334.36 366.22l-5.96 4.3 7.25 5.58 5.96-4.3-7.25-5.58z'
        />
        <path
          d='M297.46 156.13c-1.57 7.12-2.13 11.37-6.34 14.49-6.33 4.7-14.69 0-15.28-7.43-.53-6.7 2.12-17.22 9.61-19a10 10 0 0112.01 11.94z'
          style={{
            transformOrigin: '286.74px 158.218px'
          }}
          id='prefix__elqxybame5bf'
          className='prefix__animable'
          fill='#ff8b7b'
        />
        <path
          d='M303.81 145.08c6.25.17 3.68 3.46.55 5.27 0 0 3.61 1.73 1.75 5.86-2.82 6.27-8.22 13.16-13.73 12.78-6.86-.47-8.81-7.93-8.56-15.29-3.62-3.41-4.23-5.29-4.79-9.39-1.13-8.13 3.97-12.6 24.78.77z'
          style={{
            transformOrigin: '293.262px 152.789px'
          }}
          id='prefix__eltynb8negik'
          className='prefix__animable'
          fill='#263238'
        />
        <path
          d='M295.76 131.38a16.66 16.66 0 0112 20.27l-32.29-8.24a16.67 16.67 0 0120.29-12.03z'
          style={{
            transformOrigin: '291.875px 141.254px'
          }}
          id='prefix__el7cdxxpkji8c'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M295.76 131.38a16.66 16.66 0 0112 20.27l-32.29-8.24a16.67 16.67 0 0120.29-12.03z'
          style={{
            transformOrigin: '291.875px 141.254px'
          }}
          className='prefix__animable'
          fill='#fff'
          opacity={0.5}
          id='prefix__elr2n9hsoo6n8'
        />
        <path
          d='M302.14 151.67a1.44 1.44 0 01-1.41-1.82 13.34 13.34 0 00-1.91-10.69 16.14 16.14 0 00-9.63-6.75 1.46 1.46 0 01.72-2.83 19.05 19.05 0 0111.35 8 16.24 16.24 0 012.3 13 1.46 1.46 0 01-1.42 1.09z'
          style={{
            transformOrigin: '296.064px 140.603px'
          }}
          id='prefix__el0jnjpzzydzjh'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M302.14 151.67a1.44 1.44 0 01-1.41-1.82 13.34 13.34 0 00-1.91-10.69 16.14 16.14 0 00-9.63-6.75 1.46 1.46 0 01.72-2.83 19.05 19.05 0 0111.35 8 16.24 16.24 0 012.3 13 1.46 1.46 0 01-1.42 1.09z'
          style={{
            transformOrigin: '296.064px 140.603px'
          }}
          className='prefix__animable'
          fill='#fff'
          opacity={0.3}
          id='prefix__elqeclujdmes'
        />
        <path
          d='M271 143.84l38 9.7a1.54 1.54 0 001.87-1.11 1.55 1.55 0 00-1.11-1.88l-38-9.7a1.55 1.55 0 00-1.88 1.12 1.54 1.54 0 001.12 1.87z'
          style={{
            transformOrigin: '290.375px 147.195px'
          }}
          id='prefix__el5hz4plx39o'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M271 143.84l38 9.7a1.54 1.54 0 001.87-1.11 1.55 1.55 0 00-1.11-1.88l-38-9.7a1.55 1.55 0 00-1.88 1.12 1.54 1.54 0 001.12 1.87z'
          style={{
            transformOrigin: '290.375px 147.195px'
          }}
          className='prefix__animable'
          fill='#fff'
          opacity={0.3}
          id='prefix__elcikuku1py4p'
        />
        <path
          d='M287.57 155.46a8.16 8.16 0 01-2.22 4.8c-1.66 1.71-3.3.56-3.51-1.6-.19-1.94.45-5.17 2.44-6.07s3.5.7 3.29 2.87z'
          style={{
            transformOrigin: '284.699px 156.71px'
          }}
          id='prefix__el0fmkjfxhtc1'
          className='prefix__animable'
          fill='#ff8b7b'
        />
        <path
          d='M284.43 245.11s-.85 52.28 5.72 72.78c10.41 32.47 41.85 58.77 41.85 58.77l11.24-8.11s-26.18-22.22-30.98-49.55c-4.31-24.57-2.48-53.8-2.48-73.87z'
          style={{
            transformOrigin: '313.817px 310.885px'
          }}
          id='prefix__el2t0k450g9kg'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M284.43 245.11s-.85 52.28 5.72 72.78c10.41 32.47 41.85 58.77 41.85 58.77l11.24-8.11s-26.18-22.22-30.98-49.55c-4.31-24.57-2.48-53.8-2.48-73.87z'
          style={{
            transformOrigin: '313.817px 310.885px'
          }}
          className='prefix__animable'
          opacity={0.3}
          id='prefix__el1qayaldt4ak'
        />
        <path
          d='M291.76 254.09c1.39 9.42-3.52 35.65-5.22 44.24-1.78-16.06-2.11-35.11-2.14-45.51 3.6-2.44 6.72-3.07 7.36 1.27z'
          style={{
            transformOrigin: '288.202px 274.618px'
          }}
          id='prefix__elurbc5b9i46p'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M291.76 254.09c1.39 9.42-3.52 35.65-5.22 44.24-1.78-16.06-2.11-35.11-2.14-45.51 3.6-2.44 6.72-3.07 7.36 1.27z'
          style={{
            transformOrigin: '288.202px 274.618px'
          }}
          className='prefix__animable'
          opacity={0.4}
          id='prefix__el9ogdgksabpb'
        />
        <path
          d='M327.19 374.29c-.05 0 4.62 2.75 4.62 2.75l12.27-8.86-4.08-3.13z'
          style={{
            transformOrigin: '335.635px 371.045px'
          }}
          id='prefix__eltreqrqm3sb'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M327.19 374.29c-.05 0 4.62 2.75 4.62 2.75l12.27-8.86-4.08-3.13z'
          style={{
            transformOrigin: '335.635px 371.045px'
          }}
          className='prefix__animable'
          fill='#fff'
          opacity={0.4}
          id='prefix__el0nze67bzys2k'
        />
        <path
          d='M270.49 245.11s-11.07 46.9-11.85 69.3c-.87 25.13 7.9 84.39 7.9 84.39H279s1.54-59.72 2.09-82.61c.6-24.95 15.25-71.08 15.25-71.08z'
          style={{
            transformOrigin: '277.46px 321.955px'
          }}
          id='prefix__elzq4reoxv8w'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M270.49 245.11s-11.07 46.9-11.85 69.3c-.87 25.13 7.9 84.39 7.9 84.39H279s1.54-59.72 2.09-82.61c.6-24.95 15.25-71.08 15.25-71.08z'
          style={{
            transformOrigin: '277.46px 321.955px'
          }}
          className='prefix__animable'
          opacity={0.3}
          id='prefix__el6ufs6md8tn3'
        />
        <path
          d='M264.14 393.84c-.05 0 .71 5.17.71 5.17H280l.41-4.61z'
          style={{
            transformOrigin: '272.274px 396.425px'
          }}
          id='prefix__elrng5hei25k'
          className='prefix__animable'
          fill='#407bff'
        />
        <path
          d='M264.14 393.84c-.05 0 .71 5.17.71 5.17H280l.41-4.61z'
          style={{
            transformOrigin: '272.274px 396.425px'
          }}
          className='prefix__animable'
          fill='#fff'
          opacity={0.4}
          id='prefix__elb1quqq282s8'
        />
      </g>
      <defs>
        <filter id='prefix__active' height='200%'>
          <feMorphology
            in='SourceAlpha'
            result='DILATED'
            operator='dilate'
            radius={2}
          />
          <feFlood floodColor='#32DFEC' floodOpacity={1} result='PINK' />
          <feComposite in='PINK' in2='DILATED' operator='in' result='OUTLINE' />
          <feMerge>
            <feMergeNode in='OUTLINE' />
            <feMergeNode in='SourceGraphic' />
          </feMerge>
        </filter>
        <filter id='prefix__hover' height='200%'>
          <feMorphology
            in='SourceAlpha'
            result='DILATED'
            operator='dilate'
            radius={2}
          />
          <feFlood floodColor='red' floodOpacity={0.5} result='PINK' />
          <feComposite in='PINK' in2='DILATED' operator='in' result='OUTLINE' />
          <feMerge>
            <feMergeNode in='OUTLINE' />
            <feMergeNode in='SourceGraphic' />
          </feMerge>
          <feColorMatrix values='0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0' />
        </filter>
      </defs>
    </svg>
  )
}

export default SvgComponent
